import { themeAudi } from "./themeAudi";
import { getPathByPageName } from "@/tools/tools";

export const getCurrentTheme = (pathname: string, _: any, defaultTheme: any) => {
  switch (pathname) {
    case getPathByPageName("DetailSearch"):
      return defaultTheme;
    case getPathByPageName("DetailSearch") + "/audi":
      return themeAudi;
    default:
      return defaultTheme;
  }
};
